import Overlay from '../classes/overlay';

window.currentHeader = null;

$('.desktop-menu__item[mega-menu-id]').on('mouseenter', function () {
  window.currentHeader = $(this).closest('.header')[0];
  $('.mega-menu-backdrop').addClass('mega-menu-backdrop--active');
  $('.mega-menu, .mega-menu-backdrop').css(
    'top',
    window.currentHeader.getBoundingClientRect().bottom + 'px',
  );
  $('.mega-menu__item').removeClass('mega-menu__item--active');
  $('.mega-menu').css(
    'height',
    $(
      '.mega-menu__item[mega-menu-id="' + $(this).attr('mega-menu-id') + '"]',
    ).innerHeight() + 'px',
  );
  $(
    '.mega-menu__item[mega-menu-id="' + $(this).attr('mega-menu-id') + '"]',
  ).addClass('mega-menu__item--active');
});

$(window).on('scroll', function () {
  if (window.currentHeader) {
    $('.mega-menu, .mega-menu-backdrop').css(
      'top',
      window.currentHeader.getBoundingClientRect().bottom + 'px',
    );
  }
});

$('.mega-menu').on('mouseleave', function (e) {
  if (e.clientY > $(this).offset().top - $(window).scrollTop()) {
    closeMegaMenu();
  }
});

$('.desktop-menu__item[mega-menu-id]').on('mouseleave', function (e) {
  if (
    e.clientY <
    $(this).offset().top - $(window).scrollTop() + $(this).outerHeight()
  ) {
    closeMegaMenu();
  }
});

$('.desktop-menu__item:not([mega-menu-id])').on('mouseenter', closeMegaMenu);
$('.mega-menu-backdrop').on('mouseenter', closeMegaMenu);
$('[data-close-mega-menu]').on('mouseenter', closeMegaMenu);
$(window).on('resize', closeMegaMenu);

function closeMegaMenu() {
  $('.mega-menu').css('height', 0);
  $(
    '.mega-menu__item[mega-menu-id="' + $(this).attr('mega-menu-id') + '"]',
  ).removeClass('mega-menu__item--active');
  $('.mega-menu-backdrop').removeClass('mega-menu-backdrop--active');
  window.currentHeader = null;
}

$('.mobile-menu__body [data-menu-toggle]').on('click', function (e) {
  e.preventDefault();
  $(
    '.mobile-menu__body[data-menu-parent="' +
      $(this).attr('data-menu-toggle') +
      '"]',
  ).toggleClass('is-hidden');
});

new Overlay({
  toggle: '[data-action="toggle-nav"]',
  selector: 'body, .mobile-menu, .mobile-menu-backdrop',
  disableScroll: true,
});

new Overlay({
  toggle: '[data-action="toggle-filter"]',
  selector: '.s7filter, .s7filter-backdrop',
  disableScroll: true,
});
